module.exports = __webpack_public_path__ + "img/c02_unitsiegetowerchampion_Normal_ua.615f0d37.webp";